module.exports = __webpack_public_path__ + "static/media/automobile.3ba4d85b.svg";